// This file is generated automatically, do not overwrite

export enum EnergyLabel {
  ENERGY_LABEL_ZERO_ON_THE_METER = 'ZERO-ON-THE-METER',
  ENERGY_LABEL_ENERGY_NEUTRAL = 'ENERGY_NEUTRAL',
  ENERGY_LABEL_A_QUAD_PLUS_WITH_ENERGY_PERFORMANCE_GUARANTEE = 'A++++_WITH_ENERGY_PERFORMANCE_GUARANTEE',
  ENERGY_LABEL_A_QUIN_PLUS = 'A+++++',
  ENERGY_LABEL_A_QUAD_PLUS = 'A++++',
  ENERGY_LABEL_A_TRIPLE_PLUS = 'A+++',
  ENERGY_LABEL_A_DOUBLE_PLUS = 'A++',
  ENERGY_LABEL_A_PLUS = 'A+',
  ENERGY_LABEL_A = 'A',
  ENERGY_LABEL_B = 'B',
  ENERGY_LABEL_C = 'C',
  ENERGY_LABEL_D = 'D',
  ENERGY_LABEL_E = 'E',
  ENERGY_LABEL_F = 'F',
  ENERGY_LABEL_G = 'G',
  ENERGY_LABEL_UNKNOWN = 'NONE',
  ENERGY_LABEL_INVALID = 'INVALID',
}

const EnergyLabelTranslations = new Map<EnergyLabel, string>();

EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_ZERO_ON_THE_METER, 'Nul op de meter');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_ENERGY_NEUTRAL, 'Energieneutraal');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A_QUAD_PLUS_WITH_ENERGY_PERFORMANCE_GUARANTEE, 'A++++ (met energieprestatiegarantie)');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A_QUIN_PLUS, 'A+++++');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A_QUAD_PLUS, 'A++++');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A_TRIPLE_PLUS, 'A+++');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A_DOUBLE_PLUS, 'A++');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A_PLUS, 'A+');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_A, 'A');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_B, 'B');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_C, 'C');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_D, 'D');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_E, 'E');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_F, 'F');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_G, 'G');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_UNKNOWN, 'Niet bekend');
EnergyLabelTranslations.set(EnergyLabel.ENERGY_LABEL_INVALID, 'Ongeldig');

const translateEnergyLabel = (enumeration: EnergyLabel): string => {
  return EnergyLabelTranslations.get(enumeration);
}

export { EnergyLabelTranslations, translateEnergyLabel }